import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useI18n } from "../i18n";

const T = {
  success: {
    es: ["¡Listo! Tu prueba de 30 días está activa", "No te cobramos nada hoy. Puedes cancelar cuando quieras desde tu suscripción."],
    en: ["All set! Your 30-day trial is active", "We didn't charge you today. Cancel anytime from your subscription."],
    fr: ["C'est fait ! Votre essai de 30 jours est actif", "Aucun débit aujourd'hui. Annulez quand vous voulez depuis votre abonnement."],
    pt: ["Pronto! O teu teste de 30 dias está ativo", "Não cobrámos nada hoje. Cancela quando quiseres na tua subscrição."],
    it: ["Fatto! La tua prova di 30 giorni è attiva", "Nessun addebito oggi. Annulla quando vuoi dal tuo abbonamento."],
  },
  cancel: {
    es: ["Pago cancelado", "No se ha creado ninguna suscripción. Puedes intentarlo de nuevo cuando quieras."],
    en: ["Payment cancelled", "No subscription was created. You can try again anytime."],
    fr: ["Paiement annulé", "Aucun abonnement créé. Vous pouvez réessayer quand vous voulez."],
    pt: ["Pagamento cancelado", "Nenhuma subscrição criada. Podes tentar novamente quando quiseres."],
    it: ["Pagamento annullato", "Nessun abbonamento creato. Puoi riprovare quando vuoi."],
  },
  back: { es: "Ir a mi suscripción", en: "Go to my subscription", fr: "Aller à mon abonnement", pt: "Ir para a minha subscrição", it: "Vai al mio abbonamento" },
};

export default function PaymentResult({ status }) {
  const { locale } = useI18n();
  const copy = (T[status][locale] || T[status].es);
  const ok = status === "success";
  return (
    <div data-testid={`payment-${status}`} style={{ maxWidth: 560, margin: "0 auto", padding: "80px 20px", textAlign: "center" }}>
      <div style={{ fontSize: 46 }}>{ok ? "✅" : "↩️"}</div>
      <h1 style={{ fontSize: 28, color: "#075E62", marginTop: 14, fontFamily: "Newsreader, Georgia, serif" }}>{copy[0]}</h1>
      <p style={{ color: "#3A4844", marginTop: 10 }}>{copy[1]}</p>
      <Link to="/subscription" data-testid="payment-back" style={{ display: "inline-block", marginTop: 24, background: "#075E62", color: "#F7FBFA", padding: "12px 22px", borderRadius: 999, fontWeight: 600, textDecoration: "none" }}>{T.back[locale] || T.back.es}</Link>
    </div>
  );
}
